module.exports = __webpack_public_path__ + "static/media/Kit de Apoyo E1.c8716429.zip";